import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/pro-regular-svg-icons";
import { Button, Col, Flex, Row, notification } from "antd";

import { DELETE, GET, POST } from "../../../providers/useAxiosQuery";
import { system_id } from "../../../providers/companyInfo";
import {
	TableGlobalSearchAnimated,
	TablePageSize,
	TablePagination,
	TableShowingEntriesV2,
} from "../../../providers/CustomTableFilter";
import TableEvaluation from "./components/TableEvaluation";
import ModalForm from "./components/ModalForm";
import notificationErrors from "../../../providers/notificationErrors";

export default function PageEvaluation() {
	const [toggleModalForm, setToggleModalForm] = useState({
		open: false,
		data: null,
	});

	const [tableFilter, setTableFilter] = useState({
		page: 1,
		page_size: 50,
		search: "",
		sort_field: "created_at_formatted",
		sort_order: "desc",
		system_id,
		isTrash: 0,
	});

	const { data: dataUserRoles } = GET(
		`api/user_roles`,
		"user_role_select",
		(res) => {},
		false,
	);
	const { data: dataSchoolYear } = GET(
		`api/school_year`,
		"school_year_select",
		(res) => {},
		false,
	);
	const { data: dataSemester } = GET(
		`api/semester`,
		"semester_select",
		(res) => {},
		false,
	);

	const { data: dataSource, refetch: refetchSource } = GET(
		`api/form?${new URLSearchParams(tableFilter)}`,
		"form_list",
	);

	const onChangeTable = (pagination, filters, sorter) => {
		setTableFilter({
			...tableFilter,
			sort_field: sorter.columnKey,
			sort_order: sorter.order ? sorter.order.replace("end", "") : null,
			page: 1,
			page_size: "50",
		});
	};

	const { mutate: mutateChangeStatus, isLoading: isLoadingChangeStatus } = POST(
		"api/form_change_status",
		"form_list",
	);

	const handleChangeStatus = (values) => {
		let data = {
			...values,
			from: "page_evaluation",
			system_id,
		};

		mutateChangeStatus(data, {
			onSuccess: (res) => {
				if (res.success) {
					notification.success({
						message: "Form",
						description: res.message,
					});
				} else {
					notification.error({
						message: "Form",
						description: res.message,
					});
				}
			},
			onError: (err) => {
				notificationErrors(err);
			},
		});
	};

	const { mutate: mutateDeleteForm, isLoading: isLoadingDeleteForm } = DELETE(
		"api/form",
		"form_list",
	);

	const handleDelete = (values) => {
		mutateDeleteForm(values, {
			onSuccess: (res) => {
				if (res.success) {
					notification.success({
						message: "Evaluation",
						description: res.message,
					});
				} else {
					notification.error({
						message: "Evaluation",
						description: res.message,
					});
				}
			},
			onError: (err) => {
				notificationErrors(err);
			},
		});
	};

	const { mutate: mutateDuplicateForm, isLoading: isLoadingDuplicateForm } =
		POST("api/form_duplicate", "form_list");

	const handleDuplicate = (values) => {
		mutateDuplicateForm(values, {
			onSuccess: (res) => {
				if (res.success) {
					notification.success({
						message: "Evaluation",
						description: res.message,
					});
				} else {
					notification.error({
						message: "Evaluation",
						description: res.message,
					});
				}
			},
			onError: (err) => {
				notificationErrors(err);
			},
		});
	};

	useEffect(() => {
		refetchSource();

		return () => {};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [tableFilter]);

	return (
		<Row gutter={[12, 12]} id="tbl_wrapper">
			<Col xs={24} sm={24} md={24} lg={24} xl={24}>
				<Button
					icon={<FontAwesomeIcon icon={faPlus} />}
					className="w-auto btn-main-primary"
					name="btn_add"
					onClick={() =>
						setToggleModalForm({
							open: true,
							data: null,
						})
					}
				>
					Add Form
				</Button>
			</Col>
			<Col xs={24} sm={24} md={24} lg={24} xl={24}>
				<Flex justify="space-between" className="tbl-top-filter">
					<Flex gap={10}>
						<Button
							type={tableFilter.isTrash === 0 ? "primary" : "default"}
							onClick={() => {
								setTableFilter((ps) => ({
									...ps,
									isTrash: 0,
								}));
							}}
						>
							Active
						</Button>
						<Button
							type={tableFilter.isTrash === 1 ? "primary" : "default"}
							onClick={() => {
								setTableFilter((ps) => ({
									...ps,
									isTrash: 1,
								}));
							}}
						>
							Archived
						</Button>
					</Flex>

					<TablePageSize
						tableFilter={tableFilter}
						setTableFilter={setTableFilter}
					/>
				</Flex>
			</Col>

			<Col xs={24} sm={24} md={24} lg={24} xl={24}>
				<Flex justify="space-between" className="tbl-top-filter">
					<Flex gap={10}>
						<TableGlobalSearchAnimated
							tableFilter={tableFilter}
							setTableFilter={setTableFilter}
						/>
					</Flex>

					<Flex gap={15} align="center">
						<TableShowingEntriesV2 />

						<TablePagination
							tableFilter={tableFilter}
							setTableFilter={setTableFilter}
							total={dataSource?.data.total}
							showLessItems={true}
							showSizeChanger={false}
							tblIdWrapper="tbl_wrapper"
						/>
					</Flex>
				</Flex>
			</Col>

			<Col xs={24} sm={24} md={24} lg={24} xl={24}>
				<TableEvaluation
					dataSource={dataSource}
					onChangeTable={onChangeTable}
					handleChangeStatus={handleChangeStatus}
					handleDelete={handleDelete}
					isLoadingDeleteForm={isLoadingDeleteForm}
					isLoadingChangeStatus={isLoadingChangeStatus}
					setToggleModalForm={setToggleModalForm}
					handleDuplicate={handleDuplicate}
					isLoadingDuplicateForm={isLoadingDuplicateForm}
				/>
			</Col>

			<Col xs={24} sm={24} md={24} lg={24} xl={24}>
				<Flex justify="space-between" className="tbl-bottom-filter">
					<div />
					<Flex gap={15} align="center">
						<TableShowingEntriesV2 />
						<TablePagination
							tableFilter={tableFilter}
							setTableFilter={setTableFilter}
							total={dataSource?.data.total}
							showLessItems={true}
							showSizeChanger={false}
							tblIdWrapper="tbl_wrapper"
						/>
					</Flex>
				</Flex>
			</Col>

			<ModalForm
				toggleModalForm={toggleModalForm}
				setToggleModalForm={setToggleModalForm}
				dataUserRoles={dataUserRoles}
				dataSchoolYear={dataSchoolYear}
				dataSemester={dataSemester}
			/>
		</Row>
	);
}
